import Page from './Page.wrapper';

export default Page;
export { Page };
